<template>
  <!-- 意见反馈页面 -->
  <div class="feedback-page">
    <!-- 返回按钮 -->
    <div class="back-btn" @click="goBack"></div>
    <img 
      class="feedback-content" 
      :src="feedbackImage" 
      alt="反馈内容"
    >
  </div>
</template>

<script setup>
import { computed, inject, ref, onMounted, onUnmounted } from 'vue'

// Props & Emits
const emit = defineEmits(['goBack'])

// 注入的数据
const isMobile = inject('isMobile')

// 页面停留时间追踪
const viewPageStartTime = ref(null);

// 计算浏览时长
const formatDuration = (startTime, endTime) => {
  const duration = Math.floor((endTime - startTime) / 1000); // 转换为秒
  // 格式化为 xxHxxMxxS
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  return `${hours > 0 ? hours + 'H' : ''}${minutes > 0 ? minutes + 'M' : ''}${seconds}S`;
};

// 上报页面停留时间
const reportStayTime = () => {
  if (viewPageStartTime.value) {
    window.activityDataLayer.push({
      eventName: 'stay_time',
      eventType: '精选玩家心声',
      eventValue: formatDuration(viewPageStartTime.value, new Date()),
      aid: window.activity_name,
      gameId: window.game_id
    });
  }
};

// 方法
const goBack = () => {
  reportStayTime();
  emit('goBack');
}

// 根据设备类型选择图片
const feedbackImage = computed(() => {
  return isMobile.value 
    ? new URL('../../assets/images/sub-page/feedback-content_m.jpg', import.meta.url).href
    : new URL('../../assets/images/sub-page/feedback-content.jpg', import.meta.url).href
})

// 生命周期
onMounted(() => {
  viewPageStartTime.value = new Date();
});

onUnmounted(() => {
  reportStayTime();
});
</script>
